import styled from "styled-components";

export const Panel=styled.aside`
padding:0.5vw;
background-color:#33343d;
color:white;
display:block;
height:100%;
position:absolute;
top:0vw;
width:200px;
display:none;
`
